
import { Injectable } from '@nestjs/common';
import { WorkstationCategories } from '../../workstation-category/workstation-category.entity';
import { WorkStations } from '../workstations.entity';
import { WorkstationDTO } from './workstation.dto';

@Injectable()
export class WorkstationAdapter {
  /**
   * 
   * @param workstationDTO 
   * @param isUpdate 
   * @returns WorkStations entity
   */
  public convertDtoToEntity(  workstationDTO: WorkstationDTO,  isUpdate: boolean = false ): WorkStations {
    const workstation = new WorkStations();
    // workstation.workstationCategory=workstationDTO.workstation;
    workstation.workstation=workstationDTO.workstation;
    workstation.workstationCategoryInfo = new WorkstationCategories();
    workstation.workstationCategoryInfo.workstationCategoryId=workstationDTO.workstationCategoryId;
    workstation.workstationUnitCapacity=workstationDTO.workstationUnitCapacity;
    workstation.unitId=workstationDTO.unitId;
    workstation.workstationCode=workstationDTO.workstationCode;
    workstation.isActive=workstationDTO.isActive==undefined?true:workstationDTO.isActive;
    if (isUpdate) {
        workstation.updatedUser = workstationDTO.updatedUser;
        workstation.workstationId=workstationDTO.workstationId;
    } else {
        workstation.isActive = true;
        workstation.createdUser = workstationDTO.createdUser;
    }
   return workstation;
  }
  /**
   * 
   * @param workstationObject WorkStations
   * @returns WorkstationDTO
   */
  public convertEntityToDto(workstationObject: WorkStations): WorkstationDTO {
    const workstationDTO = new WorkstationDTO;
    workstationDTO.workstationId = workstationObject.workstationId;
    workstationDTO.workstation = workstationObject.workstation;
    workstationDTO.workstationCategoryId = workstationObject.workstationCategoryId;
    workstationDTO.workstationUnitCapacity = workstationObject.workstationUnitCapacity;
    workstationDTO.workstationCategoryName = workstationObject.workstationCategoryInfo.workstationCategory;
    workstationDTO.isActive = workstationObject.isActive;
    workstationDTO.createdAt = workstationObject.createdAt;
    workstationDTO.updatedAt = workstationObject.updatedAt;
    workstationDTO.createdUser = workstationObject.createdUser;
    workstationDTO.updatedUser = workstationObject.updatedUser;
    workstationDTO.versionFlag = workstationObject.versionFlag;
    workstationDTO.workstationCode=workstationObject.workstationCode;
    return workstationDTO;
  }
}
